import { appendString } from '@v/util/briqRamdaExt.js'

export const isLowerThanMaxPersons = (value, vm) =>
  vm.MinPersons && vm.MaxPersons ? parseInt(value) <= parseInt(vm.MaxPersons) : true

export const startDateIsBeforeOrEqualToEndDate = (_value, vm) => {
  return compareStartEndDates(vm.StartDate, vm.EndDate)
}

export const dealAvailbilityStartDateIsBeforeOrEqualToEndDate = (_value, vm) => {
  return compareStartEndDates(vm.AvailabilityStartDate, vm.AvailabilityEndDate)
}

const compareStartEndDates = (startDate, endDate) => {
  if (!startDate || !endDate) return true

  if (new Date(startDate) > new Date(endDate)) return false
  else return true
}

export const scheduleStartEndTimeValidation = startOfDayTime => (_value, vm) => {
  if (!vm.StartTime || !vm.EndTime) return true
  return startEndTimeValidation({
    startOfDayTime,
    startTime: vm.StartTime,
    endTime: vm.EndTime,
    allowTwentyfourHours: true,
  })
}

export const dealAvailabilityStartEndTimeValidation = startOfDayTime => value => {
  if (value === null) return true
  return startEndTimeValidation({
    startOfDayTime,
    startTime: value.StartTime,
    endTime: value.EndTime,
    allowTwentyfourHours: false,
  })
}

const startEndTimeValidation = ({ startOfDayTime, startTime, endTime, allowTwentyfourHours }) => {
  const startOfDayTimeValue =
    startOfDayTime.length === 5 ? appendString(':00')(startOfDayTime) : startOfDayTime
  // Given:
  // T: start of day
  // S: deal start time
  // E: deal end time
  // 00:00                   00:00                   00:00
  // --|-------------T---------|-------------T---------|
  //
  // Valid situations:
  //
  // Situation 1: E > S >= T
  // --|-------------T---S-E---|-------------T---------|
  //
  // Situation 2: T >= E > S
  // --|-------------T---------|------S-E----T---------|
  //
  // Situation 3: S > T >= E
  // --|-------------T----S----|---E---------T---------|
  //
  // Situation 4: S = T = E (24 hours)
  // --|-------------S---------|-------------E---------|
  //
  // Situation 5: S >= T > E
  // --|-------------T----S----|---E---------T---------|
  //
  const situation1 = startTime >= startOfDayTimeValue && endTime > startTime // E > S >= T
  const situation2 = startOfDayTimeValue >= endTime && endTime > startTime // T >= E > S
  const situation3 = startTime > startOfDayTimeValue && startOfDayTimeValue >= endTime // S > T >= E
  const situation4 = allowTwentyfourHours
    ? startTime === startOfDayTimeValue && endTime === startOfDayTimeValue // S = T = E
    : false
  const situation5 = startTime >= startOfDayTimeValue && startOfDayTimeValue > endTime // S >= T > E
  return situation1 || situation2 || situation3 || situation4 || situation5
}
